module.exports = __webpack_public_path__ + "static/andreas-15d27bdb1fe7715d093dd1fad18296a8.jpg";